import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import fp from 'lodash/fp';

import defaultStyles from './TitleCell.module.scss';
import MonitoringStatusPill from '../../../../common/monitoringStatusPill/MonitoringStatusPill';

const TitleCell = (props) => {
    const status = fp.get('status.status')(props);
    const statusColour = fp.get('status.colour')(props);
    return (
        <div className={ classnames({
            [props.styles.titleCell]: true,
            [props.styles.csaTitle]: props.titleRow,
            [props.styles.pledge]: props.value === 'Pledge' || props.filtered,
            [props.styles.receive]: props.value === 'Receive' && !props.filtered,
            [props.styles.borderBottom]: (props.title === 'Receive' && props.value !== 'Receive') || props.filtered,
            [props.styles.background]: props.title === 'Pledge' || props.filtered,
            [props.styles.csaType]: props.typeRow
        }) }
        >
            <div className={ classnames({
                [props.styles.alignRight]: props.alignRight,
                [props.styles.receiveInner]: props.value === 'Receive',
                [props.styles.titleRow]: true
            }) }
            >
                <div className={ props.styles.titleValue }>{ props.value }</div>
                { status ? (
                    <div className={ props.styles.titleStatus }>
                        <MonitoringStatusPill
                            status={ status }
                            colour={ statusColour }
                        />
                    </div>
                ) : null }
                { props.error.length ? (
                    <div className={ props.styles.titleError }>
                        { props.error }
                    </div>
                ) : null }
            </div>
        </div>
    );
};

TitleCell.propTypes = {
    alignRight: PropTypes.bool,
    error: PropTypes.string,
    styles: PropTypes.objectOf(PropTypes.string),
    title: PropTypes.string,
    titleRow: PropTypes.bool,
    value: PropTypes.string,
    filtered: PropTypes.bool,
    typeRow: PropTypes.bool
};

TitleCell.defaultProps = {
    alignRight: false,
    error: '',
    styles: defaultStyles,
    title: '',
    titleRow: false,
    value: '',
    filtered: false,
    typeRow: false
};

export default TitleCell;
